import { and, any, complement, pipe, props } from 'ramda';

const preMatchListPageNames = [
  'preMatchFavorites',
  'preMatchSport',
  'preMatchCategory',
  'preMatchTournament',
  'preMatchFilter',
  'customFilter'
];

const topEventsListPageNames = ['topEvents'];

const liveListPageNames = ['liveFavorites', 'liveSport', 'liveSportAll'];

const cyberSportListPages = [
  'cyberSport',
  'cyberSportCategory',
  'cyberSportTournament',
  'cyberSportFavorites'
];

const listPageNames = [
  ...preMatchListPageNames,
  ...topEventsListPageNames,
  ...liveListPageNames,
  ...cyberSportListPages
];

type Routes = { [key: string]: string };

export const isDetailsPage = (pathname = '', routes: Routes) =>
  [routes.preMatchEvent, routes.liveEvent].some((pagePath) =>
    pathname.startsWith(pagePath)
  );

const isPageOfType =
  (pageNames: string[]) => (pathname: string, routes: Routes) =>
    pipe(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      props(pageNames),
      any((page: string) => pathname.startsWith(page))
    )(routes);

export const isListPage = and(
  isPageOfType(listPageNames),
  complement(isDetailsPage)
);

export const isPreMatchSportsPage = (pathname: string, routes: Routes) =>
  pathname.startsWith(routes.preMatchSport);

export const isLiveListPage = isPageOfType(liveListPageNames);
